export function Spinner({ size = 16, color = 'white' }) {
  return (
    <svg
      className="animate-spin"
      style={{ width: size, height: size }}
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12" cy="12" r="10"
        stroke={color}
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill={color}
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );
}

export function LoadingButton({
  loading,
  loadingText,
  children,
  className = '',
  spinnerColor = 'white',
  ...props
}) {
  return (
    <button
      {...props}
      disabled={loading || props.disabled}
      className={`inline-flex items-center justify-center gap-2 ${className} disabled:opacity-60`}
    >
      {loading && <Spinner size={14} color={spinnerColor} />}
      {loading ? (loadingText || children) : children}
    </button>
  );
}
